import React from "react";
import {IGameContextViewModel} from "../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {GameWindowBox} from "../boxes/game-window.box";
import {GameDetailHistoryBodyBox} from "../../game-body/boxes/body/game-detail-history-body.box";
import {ComponentServicesPick} from "../../../../services/component-services-pick";
import {observer} from "mobx-react";
import {withServices} from "../../../../react-hooks/with-services";
import {GameWindowInnerWrapperBox} from "../boxes/game-window-inner-wrapper.box";

interface GameHistoryWindowComponentProps extends ComponentServicesPick<'gameRunner'>{
    gameContext: IGameContextViewModel;
}

const ComponentBody: React.FC<GameHistoryWindowComponentProps> = observer((props) => {
    const _captureGameBodyContainerElementRef = (element: HTMLElement) => {
        if(element) {
            props.gameContext.gameParts.bodyRenderer?.setGamePartElementRef(element);
        }
    }

    const _captureElementRef = (element: HTMLElement) => {
        if(element) {
            props.gameContext.gameParts.windowRenderer?.setGamePartElementRef(element);
        }
    }

    const backgroundImage = props.gameContext.gameInfo.getBackgroundImage();
    return (
        <GameWindowBox key={`${props.gameContext.gameInfo.gameType}_${props.gameContext.gameMode}`}
                       zIndex={props.gameRunner.gameFrameZIndex}
                       ref={_captureElementRef}>
            {props.gameContext.gameParts.leftBarRenderer?.render()}

            <GameWindowInnerWrapperBox className="game_column_flex_wrapper">
                {props.gameContext.gameParts.headerBarRenderer?.render()}

                <GameDetailHistoryBodyBox backgroundImageUrl={backgroundImage} ref={_captureGameBodyContainerElementRef}>
                    {props.gameContext.gameParts.bodyRenderer?.render()}
                </GameDetailHistoryBodyBox>

                {props.gameContext.gameParts.footerBarRenderer?.render()}
            </GameWindowInnerWrapperBox>

            {props.gameContext.gameParts.rightBarRenderer?.render()}
        </GameWindowBox>
    )
})

export const GameDetailHistoryWindowComponent = withServices(ComponentBody, ['gameRunner']);